export default "__VITE_ASSET__DoKIC_KX__"